import { useQuery } from '@tanstack/react-query';
import { APP_PREVIEW_QUERY_KEYS } from '@/lib/constants/appPreview';
import { useResellerBrand } from '@/shared/hooks/useResellerBrand';
import { AppPreviewApi } from './AppPreviewApi';

/**
 * Live /app/v1 reads for the TV preview, keyed by the app's public domain.
 * Both payloads are public and server-cached (~2 min) — a failed tenant
 * lookup (403/404) is a real answer, not a transient, so retry once only.
 */
export function useAppPreviewCfg(appDomain: string | null) {
  const isReseller = useResellerBrand();
  return useQuery({
    queryKey: APP_PREVIEW_QUERY_KEYS.cfg(appDomain ?? ''),
    queryFn: () => AppPreviewApi.getCfg(appDomain!, isReseller),
    enabled: appDomain != null,
    staleTime: 60_000,
    retry: 1,
  });
}

export function useAppPreviewBrowse(appDomain: string | null) {
  const isReseller = useResellerBrand();
  return useQuery({
    queryKey: APP_PREVIEW_QUERY_KEYS.browse(appDomain ?? ''),
    queryFn: () => AppPreviewApi.getBrowse(appDomain!, isReseller),
    enabled: appDomain != null,
    staleTime: 60_000,
    retry: 1,
  });
}
